// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-index-js": () => import("./../src/pages/about/index.js" /* webpackChunkName: "component---src-pages-about-index-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-post-20-js": () => import("./../src/templates/post20.js" /* webpackChunkName: "component---src-templates-post-20-js" */),
  "component---src-templates-postshop-js": () => import("./../src/templates/postshop.js" /* webpackChunkName: "component---src-templates-postshop-js" */)
}

